import { render, staticRenderFns } from "./zhiyeku.vue?vue&type=template&id=1be4b62c&scoped=true"
import script from "./zhiyeku.vue?vue&type=script&lang=js"
export * from "./zhiyeku.vue?vue&type=script&lang=js"
import style0 from "./zhiyeku.vue?vue&type=style&index=0&id=1be4b62c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4b62c",
  null
  
)

export default component.exports